import TYPES from '@/types';

// Domain
import {
  InvestorProfileOnEmergencyFundRepository,
} from '@/modules/flagship/investor-profile/emergency-fund/domain/repositories/investor-profile-on-emergency-fund-repository';
import {
  InvestorProfileEntity,
} from '@/modules/flagship/investor-profile/investor-profile/domain/entities/investor-profile-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class InvestorProfileOnEmergencyFundHttpRepository
implements InvestorProfileOnEmergencyFundRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-profile/emergency-fund/{investor_profile_id}/`;

  update(investor_profile_entity: InvestorProfileEntity): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.replace('{investor_profile_id}', investor_profile_entity.id!), 'PATCH', {
        emergency_fund_availability_id: investor_profile_entity.emergency_fund_availability_id,
        has_emergency_fund: investor_profile_entity.has_emergency_fund,
        emergency_fund_amount: investor_profile_entity.emergency_fund_amount,
      })
        .then((response) => {
          if (response.ok) {
            resolve();
          } else {
            response.json().then(
              ({ message }) => {
                reject(new Error(message));
              },
            );
          }
        })
        .catch(reject);
    });
  }
}
